import { LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';

import { NotificationModalData } from '../domain';

@Component({
  selector: 'rma-notification-modal',
  imports: [MatButtonModule, MatDialogModule, RouterModule, TranslocoModule, LowerCasePipe],
  templateUrl: './notification-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope('siteWideNotification')],
  host: {
    '(document:click)': 'closeModal($event)',
  },
})
export class NotificationModalComponent {
  private readonly modalRef: MatDialogRef<NotificationModalComponent> = inject(MatDialogRef);
  public readonly data: NotificationModalData = inject(MAT_DIALOG_DATA);

  public closeModal(event: Event): void {
    const target = event.target as HTMLElement;
    const anchor = target.closest('a');

    // Make sure the modal closes and therefore the notification is dismissed when
    // any links embedded in the modal messaging are clicked except the CTA button
    // The CTA is handled separately and also marks the notification as actioned
    if (anchor && anchor.id !== 'notificationModalCta') {
      this.modalRef.close();
    }
  }
}
